import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import {CookieService} from 'ngx-cookie-service';
import { AuthService, User} from '.././auth/auth.service';
import { ApiService } from '../../../services/api.service';


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class LoginComponent implements OnInit {
    hide = true;
    selectedRole: string;
    form: FormGroup;
    path: string;
    private formSubmitAttempt: boolean;
    [x: string]: any;  
    Mobilenumber = '';  
    name = '';  
    Password = '';  
    public checkrememberme:boolean = false;
    public remembermeFlag :boolean = false;
    Obj: User;  


    constructor(
        private fuseConfigService: FuseConfigService,
        private formBuilder: FormBuilder,private authService: AuthService,private cookieService: CookieService
    ) {

        // this.Obj = new User(); 
        this.fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // ngOnInit(): void {
    //     this.form = this.formBuilder.group({
    //         Mobilenumber: ['', [Validators.required]],
    //         Password: ['', Validators.required]
    //     });
    // }


    ngOnInit(): void {
        this.form = this.formBuilder.group({
            //Mobilenumber: ['', [Validators.required]],
            name: ['', [Validators.required]],
            Password: ['', Validators.required],
            // rememberme:[false]
            rememberme: ['']
        });
        var test = this.cookieService.getAll();   
        var testRememberme = this.cookieService.get('rememberme');
        if(testRememberme == "true")
        {     
        //this.Mobilenumber = this.cookieService.get('Mobilenumber');  
        this.name = this.cookieService.get('name');  
        this.Password = this.cookieService.get('Password');
        // var testRememberme = this.cookieService.get('rememberme');       
        this.rememberme = this.cookieService.get('rememberme');
        this.form.setValue({ name: this.name, Password:  this.Password,rememberme:this.rememberme });
        }    
    }


    isFieldInvalid(field: string) {
        return (
            (!this.form.get(field).valid && this.form.get(field).touched) ||
            (this.form.get(field).untouched && this.formSubmitAttempt)
        );

    }



    onSubmit() {
        // ;
        if (this.form.valid) {
            this.Obj = new User(); 
            this.Obj.name = this.form.value.name;  
            this.Obj.Password =  this.form.value.Password; 
            this.Obj.rememberme =  this.form.value.rememberme;
            const a = this.Obj; 
            this.cookieService.set('name', this.form.value.name);  
            this.cookieService.set('Password', this.form.value.Password);  
            if (this.remembermeFlag == true)
            this.cookieService.set('rememberme', "true");
            else
            this.cookieService.set('rememberme', "false");
            var test = this.cookieService.getAll();   
            // this.router.navigate(['/apps/dashboards/project']);  
       // }
       
            this.authService.login(this.form.value);        
           
        }
        this.formSubmitAttempt = true;
    
    }


    onChange(rememberMeButton,event){
        // ;
        if (this.form.valid) {
            // this.authService.login(this.form.value);
        }
        this.formSubmitAttempt = true; 

        if (this.form.value.rememberme == true && this.form.value.name !== "" && this.form.value.Password !== "") {
            
            localStorage.name = this.form.value.name;
            localStorage.Password = this.form.value.Password;
            localStorage.checkbox = this.form.value.rememberme;
          } else {
            localStorage.name = "";
            localStorage.Password="";
            // localStorage.checkbox = "";
            localStorage.checkbox = "";
          }
          this.remembermeFlag = true;
       if (event == true)
          this.form.value.rememberme = "true";
        else
        this.form.value.rememberme = "false";    

    }

    // refreshComponent(){
    //     this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
    //       this.router.navigate(['/apps/forgotpassword/Forgotpassword']);
    //     }); 
    // }

    ForgotPassword(){
         //this.refreshComponent();  
        //window.location.reload();
        this.router.navigate(['/apps/forgotpassword/Forgotpassword']);
    }
}
